import { createAsyncReducer } from '../../standard-actions/';
import {
    ILoadCompanyAction,
    ILoadCompanySuccessAction,
    LoadCompanyErrorAction
} from '../actions/load-company';
import { IServiceRequestsState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadCompanyAction
    = ILoadCompanyAction
    | ILoadCompanySuccessAction
    | LoadCompanyErrorAction;

const init = (state: IServiceRequestsState, action: LoadCompanyAction) => ({
    ...state,
    company: {
        ...initialState.company,
        status: action.status
    }
});

const success = (state: IServiceRequestsState, action: LoadCompanyAction) => ({
    ...state,
    company: {
        ...initialState.company,
        status: action.status,
        data: (action as ILoadCompanySuccessAction).data
    }
});

const failure = (state: IServiceRequestsState, action: LoadCompanyAction) => ({
    ...state,
    company: {
        ...initialState.company,
        status: action.status,
        error: (action as LoadCompanyErrorAction).error
    }
});
const reset = (state: IServiceRequestsState, action: LoadCompanyAction) => {
    return ({
        ...state,
        company: {
            ...initialState.company,
            status: action.status,
            data: {
                data: []
            }
        }
    });
}

export const loadCompanyReducer = createAsyncReducer(initialState, init, success, failure, reset);
